import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AffiliateAccountStatus } from '@avanzu/types';
import { useAuth } from '../contexts/AuthContext';

/**
 * Gates the affiliate dashboard pages: anyone not APPROVED is sent to the
 * program page, which renders the apply form / pending / suspended states.
 */
export const RequireAffiliateApproved: React.FC = () => {
  const { affiliateStatus } = useAuth();

  if (affiliateStatus !== AffiliateAccountStatus.APPROVED) {
    return <Navigate to="/app/affiliate-program" replace />;
  }

  return <Outlet />;
};

export default RequireAffiliateApproved;
